import React, { useEffect } from 'react'
import { HeaderReimburse } from '../../../components/Header/HeaderReimburse'
import { SingleRequest } from '../../../components/Reimbursement/SingleRequest'

export const AddReimburse = () => {
  useEffect(() => {
    var nav_item = document.getElementById('addReimburse')
    nav_item.classList.add('navlinkactive')
  }, [])

  return (
    <div className="container p-3 d-flex align-items-center justify-content-center flex-column">
      <HeaderReimburse />
      <h5 className="mb-4 mx-2 mt-5">Request for Reimbursement</h5>

      <div className="card p-5 w-100">
        <SingleRequest />
      </div>
    </div>
  )
}
